import { processEnv } from 'components/configuration/environmentVariables'

export const MONTH_DATE_YEAR_FORMAT = 'MM/dd/yyyy'

export const CDN_BASE_URL = processEnv.REACT_APP_CdnBaseUrl

export const BADGELESS_EXCLUDED_LISTING_LEVELS = [
    'Premium MasterSpec',
    'Premium',
    'Premium Proprietary',
]
